import React, { createContext, useContext, useEffect, useState } from 'react';

const AdminLanguageContext = createContext(null);

export const AdminLanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(
    () => localStorage.getItem('adminLanguage') === 'tm' ? 'tm' : 'ru'
  );

  const setLanguage = (nextLanguage) => {
    const normalizedLanguage = nextLanguage === 'tm' ? 'tm' : 'ru';
    localStorage.setItem('adminLanguage', normalizedLanguage);
    setLanguageState(normalizedLanguage);
  };

  useEffect(() => {
    localStorage.setItem('adminLanguage', language);
  }, [language]);

  return (
    <AdminLanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </AdminLanguageContext.Provider>
  );
};

export const useAdminLanguage = () => {
  const context = useContext(AdminLanguageContext);
  if (!context) {
    throw new Error('useAdminLanguage must be used within AdminLanguageProvider');
  }
  return context;
};
